
const config = {
  steps: [
    { step: 10, title: "投稿" },
    { step: 20, title: "等待编辑审稿" },
    { step: 21, title: "等待作者改稿" },
    { step: 22, title: "等待编辑审稿" },
    { step: 30, title: "等待登记版面费" },
    { step: 35, title: "等待核对审稿费缴纳" },
    { step: 40, title: "等待支付版面费" },
    { step: 50, title: "等待专家审稿" },
    { step: 51, title: "等待作者改稿" },
    { step: 52, title: "等待专家审稿" },
    { step: 53, title: "等待上传著作权许可书" },
    { step: 60, title: "等待查重" },
    { step: 61, title: "等待作者改稿" },
    { step: 62, title: "等待编辑审稿" },
    { step: 63, title: "等待二次查重" },
    { step: 99, title: "完成" },
  ],
}



export default config